(() => {
  const KEY = 'pradipatva_acquisition_v2';
  const SYNCED = `${KEY}_synced`;
  const clean = (value, limit = 180) => String(value || '').trim().slice(0, limit);

  function storeFirstTouch() {
    const params = new URLSearchParams(location.search);
    let externalReferrer = '';
    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin !== location.origin) externalReferrer = clean(referrer.origin, 240);
    } catch (_) {}

    const data = {
      source: clean(params.get('utm_source')),
      medium: clean(params.get('utm_medium')),
      campaign: clean(params.get('utm_campaign')),
      content: clean(params.get('utm_content')),
      term: clean(params.get('utm_term')),
      landing: clean(location.pathname, 240),
      referrer: externalReferrer
    };

    const hasSignal = Object.values(data).slice(0, 5).some(Boolean) || data.referrer;
    if (!hasSignal) return;
    try {
      if (!localStorage.getItem(KEY)) localStorage.setItem(KEY, JSON.stringify(data));
    } catch (_) {}
  }

  function readAttribution() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (_) {
      return null;
    }
  }

  function track(name, detail = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
  }

  async function syncAttribution() {
    const data = readAttribution();
    if (!data || typeof data !== 'object' || Array.isArray(data)) return;
    try { if (sessionStorage.getItem(SYNCED)) return; } catch (_) {}
    const attributes = {};
    ['source', 'medium', 'campaign', 'content', 'term', 'landing', 'referrer'].forEach((key) => {
      if (typeof data[key] !== 'string') return;
      let value = clean(data[key]);
      if (key === 'landing') value = value.split(/[?#]/)[0];
      if (key === 'referrer') {
        try { value = new URL(value).origin; } catch (_) { value = ''; }
      }
      if (value) attributes[`Acquisition ${key}`] = value;
    });
    if (!Object.keys(attributes).length) return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes })
      });
      if (response.ok) sessionStorage.setItem(SYNCED, '1');
    } catch (_) {}
  }

  function scheduleSync(delay = 800) {
    window.setTimeout(() => {
      if ('requestIdleCallback' in window) requestIdleCallback(() => syncAttribution(), { timeout: 1200 });
      else syncAttribution();
    }, delay);
  }

  function setupCollection() {
    const main = document.querySelector('main[data-template^="collection"]');
    const hero = main?.querySelector('[data-phase3-collection-hero]');
    if (!main || !hero) return;
    const sections = [...main.children].filter((element) => element.classList?.contains('shopify-section'));
    if (sections[0]) {
      sections[0].hidden = true;
      sections[0].setAttribute('aria-hidden', 'true');
    }
    const products = sections.at(-1);
    if (products) products.id = 'phase3-collection-products';
  }

  function moveProductPanel() {
    const panel = document.querySelector('[data-phase3-pdp-acquisition]');
    if (!panel) return;
    const confidence = document.querySelector('[data-phase2-pdp-confidence]');
    const details = document.querySelector('main[data-template^="product"] .product-details');
    if (confidence && confidence.nextElementSibling !== panel) confidence.insertAdjacentElement('afterend', panel);
    else if (details && !details.contains(panel)) details.appendChild(panel);
  }

  document.addEventListener('click', async (event) => {
    const tracked = event.target.closest('[data-phase3-track]');
    if (tracked) {
      track('pradipatva_acquisition_click', {
        label: clean(tracked.dataset.phase3Track),
        href: clean(tracked.href, 300)
      });
    }

    const addToCart = event.target.closest('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"]');
    if (addToCart) scheduleSync(1100);

    const checkout = event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
    if (checkout) syncAttribution();

    const share = event.target.closest('[data-phase3-share]');
    if (!share) return;
    const title = share.dataset.shareTitle || document.title;
    const url = share.dataset.shareUrl || location.href;
    try {
      if (navigator.share) await navigator.share({ title, url });
      else {
        await navigator.clipboard.writeText(url);
        const previous = share.textContent;
        share.textContent = 'Link copied';
        window.setTimeout(() => { share.textContent = previous; }, 1600);
      }
      track('pradipatva_product_share', { title, url });
    } catch (_) {}
  });

  function init() {
    storeFirstTouch();
    setupCollection();
    moveProductPanel();
    if (document.querySelector('main[data-template^="cart"]')) scheduleSync(0);
    if (document.querySelector('[data-phase3-pdp-acquisition]')) window.setTimeout(moveProductPanel, 350);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();